import openMenu from "./components/open-menu";
import scrollTop from "./components/scroll-top";
import sliderCategoryMenu from "./components/slider-category-menu"
import sliderCave from "./components/slider-cave";
import stickyNavigation from "./components/sticky-navigation";

openMenu.init();
scrollTop.init();
sliderCategoryMenu.init();
stickyNavigation.init();
sliderCave.init();



// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
let vh = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty('--vh', `${vh}px`);



